import React, {Component} from 'react';
import './App.scss';
import {Outlet} from "react-router-dom";
import {initIconsLibrary} from "./utils/init_icons_library";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {SupportChatEntry} from "./components/support_chat/SupportChatEntry";
import FeedbackWidgetEntry from "./components/feedback_widget/FeedbackWidgetEntry";
import {RouteTracker} from "./components/RouteTracker";
import {ClarityTracker} from "./components/ClarityTracker";
import {ErrorBoundary} from "./components/ErrorBoundary";
import {AgencyStatusRefresher} from "./components/AgencyStatusRefresher";
import {FreeTrialBanner} from "./components/FreeTrialBanner";
import {OverduePaymentBanner} from "./components/OverduePaymentBanner";
import {DisconnectedCredentialsBanner} from "./components/DisconnectedCredentialsBanner";
import {PendingInvitationBanner} from "./components/PendingInvitationBanner";
import "./components/AppBanners.scss";
import {UserModulesProvider} from "./context/UserModulesContext";
import {PendingWorkProvider} from "./context/PendingWorkContext";
import {BoosterFlowProvider} from "./context/BoosterFlowContext";
import {PendingWorkNotifier} from "./components/PendingWorkNotifier";
import {GuidesProvider} from "./guides/GuidesContext";
import GuidesEntry from "./guides/GuidesEntry";
// import {MaintenanceBanner} from "./components/MaintenanceBanner";


initIconsLibrary();

class App extends Component {
    render() {
        return (
            <ErrorBoundary showDetails={process.env.NODE_ENV === 'development'}>
                <UserModulesProvider>
                {/* Guías in-app (reemplazo de los Product Tours de Intercom). Acá arriba por la misma
                    razón que el trabajo pendiente: una guía puede cruzar pantallas y el tope de una
                    automática por sesión es de la pestaña, no de una pantalla. Adentro del provider
                    de módulos porque el gate (`guides_enabled`) viaja en ese payload. */}
                <GuidesProvider>
                {/* El trabajo pendiente se consulta UNA vez para toda la app: `App` es lo único que
                    no remonta al navegar, y el aviso tiene que encontrar al usuario esté donde
                    esté. Va dentro del provider de módulos porque necesita el nivel de Memoria para
                    decidir si siquiera hay algo que preguntar. */}
                <PendingWorkProvider>
                {/* Qué acto del Recorrido se está mirando. Va acá arriba porque lo escribe el
                    contenido (el observer de secciones) y lo lee el sidebar, que es su hermano:
                    más abajo no habría ancestro común. */}
                <BoosterFlowProvider>
                <div>
                    {/* Los banners globales se APILAN en un contenedor sticky único: cada uno era
                        `sticky; top: 0` por su cuenta y, con dos a la vez, el segundo tapaba al
                        primero entero (QA-VIS-invit-04). El orden es la prioridad de lectura. */}
                    <div className="app-banners">
                        {/* <MaintenanceBanner/> */}
                        <OverduePaymentBanner/>
                        <DisconnectedCredentialsBanner/>
                        <FreeTrialBanner/>
                        <PendingInvitationBanner/>
                    </div>
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <SupportChatEntry/>
                    {/* Widget de feedback de la UX 2.1 (no aparece en el clásico). Trae su propio
                        ErrorBoundary: el de arriba pinta pantalla completa, y un bug del widget no
                        puede tumbar la app. */}
                    <FeedbackWidgetEntry/>
                    {/* Trae su propio ErrorBoundary, igual que el widget de feedback. */}
                    <GuidesEntry/>
                    <RouteTracker/>
                    {/* Grabaciones de Clarity: sólo el alta y las agencias en prueba (UD-7 de /ux). */}
                    <ClarityTracker/>
                    <AgencyStatusRefresher/>
                    <PendingWorkNotifier/>
                    <Outlet/>
                </div>
                </BoosterFlowProvider>
                </PendingWorkProvider>
                </GuidesProvider>
                </UserModulesProvider>
            </ErrorBoundary>
        );
    }
}


export default App;
